import { useRef } from 'react';

import { useScaleCanvas } from '../use-scale-canvas';
import SparkleSvg from '../images/sparkle.svg';
import rebrandCard from './SkillsImages/rebrand.svg';
import skillsCards from './SkillsImages/skillscards.svg';

const CANVAS_W = 640;
const CANVAS_H = 660;

export const SkillsShowcase = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { wrapperStyle, canvasStyle } = useScaleCanvas(sectionRef, CANVAS_W, CANVAS_H, 'contain');

  return (
    <section
      ref={sectionRef}
      className='relative h-full w-full overflow-hidden bg-secondary-brand-25'
    >
      <div className='absolute inset-0 flex items-end justify-end'>
        <div style={wrapperStyle}>
          <div style={canvasStyle}>
            <img
              src={skillsCards}
              alt=''
              className='absolute'
              style={{ top: 193, left: 79, width: 561, height: 467 }}
            />
          </div>
        </div>
      </div>

      <div className='absolute inset-0 bg-gradient-to-t from-secondary-brand-50 from-[23%] to-secondary-brand-25 to-[95%] opacity-70' />

      <div className='absolute inset-0 flex items-end justify-end'>
        <div style={wrapperStyle}>
          <div style={canvasStyle}>
            <div className='absolute left-2 top-10 w-[590px]'>
              <h1 className='m-0 text-display-md font-bold text-gray-700'>
                The World Needs What You Know
              </h1>
              <p className='mb-0 mt-4 text-base font-normal text-gray-700'>
                Real impact starts when you show up—just as you are.
              </p>
            </div>

            <img src={SparkleSvg} alt='' className='absolute left-0 top-64 w-32' />
            <img
              src={rebrandCard}
              alt=''
              className='absolute'
              style={{ top: 331, left: 63, width: 387, height: 134 }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
